import { INBOUND_CORR_WB_REPORT,PART_D_DUPLICATE_REPORT,PART_D_IE_REPORT,PART_D_MULTIPLE_REPORT,XCPINDEXING_REPORT,FUTURE_COVERAGE_REPORT,DUAL_ACCOUNT_REPORT,UHCEI_DUPLICATE_DENIAL_REPORT,RESOLVED_COMPLETED_REPORT, TRANSITIONAL_OVERRIDE_REPORT, PART_D_PREDETERMINATION_REPORT } from "./reportNames"

export const REPORT_CONDITONS = {

    [INBOUND_CORR_WB_REPORT]:{

          19:[
              [{id: 18, value_id: 2, key: 1}],
              [{id: 18, value_id: 3, key: 1}]
          ],
          21:[
               [{id: 20,value_id:6,key:1}]
          ],
          22:[
              [{id: 21, value_id: 9, key: 1}]
          ],
          // There is some doubt in this file as condition data is not clear
          23:[
              [{id: 21, value_id: 9, key: 1}]
          ],
          26:[
              [{id: 25, value_id: 17, key: 1}]
          ],
          27:[
              [{id: 25, value_id: 17, key: 1}]
          ],
          28:[
              [{id: 25, value_id: 17, key: 1}]
          ],
          29:[
              [{id: 25, value_id: 17, key: 1}]
          ],
          
      },

       
      [PART_D_DUPLICATE_REPORT]: {


          32:[
              [{id: 31, value_id: 2, key: 1}],
              [{id: 31, value_id: 3, key: 1}]
        ],
        33:[
             [{id: 31, value_id: 1, key: 1}]
        ],
        35:[
         [{id: 34, value_id: 31, key: 1}]
        ],
        36:[
            [{id: 31, value_id: 1,key: 1, neq: true}],
            [{id: 34, value_id: 30,key: 1, neq: true}]
           ],
        37:[
            [{id: 31, value_id: 1,key: 1, neq: true}],
            [{id: 34, value_id: 30,key: 1, neq: true}]
        ],
        38:[
         [{id: 37, value_id: 45, key: 1}]
        ],
        39:[
         [{id: 38, value_id: 85, key: 1}],
         [{id: 38, value_id: 86, key: 1}],
         [{id: 38, value_id: 87, key: 1}]
        ],
        40:[
          [{id: 31, value_id: 2, key: 1}],
          [{id: 31, value_id: 3, key: 1}],
          [{id: 37, value_id: 45, key: 1}]
         ],
        41:[
         [{id: 31, value_id: 3, key: 1}],
         [{id: 31, value_id: 2, key: 1}],
         [{id: 37, value_id: 45, key: 1}]
        ],
        195:[
            [{id: 31, value_id: 2, key: 1}]
        ]
        
      },

  
 [DUAL_ACCOUNT_REPORT]: {


          2: [
              [{id: 1, value_id: 2, key: 1}],
              [{id: 1, value_id: 3, key: 1}]
          ],
          4:[
              [{id:3,value_id: 7, key: 1}]
          ],
          5:[
              [{id: 3, value_id: 7, key: 1}]
          ],
          6:[
            [{id: 5, value_id: 11, key: 1}]
          ],
          7:[
              [{id: 5, value_id: 11, key: 1}]
          ],
          8:[
              [{id: 5, value_id: 12, key: 1}],
              [{id: 2, value_id: 5, key: 1}]
          ],
          10:[
              [{id: 5, value_id: 12, key: 1}],
              [{id: 2, value_id: 5, key: 1}]
          ],
          11:[
              [{id: 5, value_id: 12, key: 1}],
              [{id: 2, value_id: 5, key: 1}]
          ],
          12:[
              [{id: 5, value_id: 12, key: 1}],
              [{id: 2, value_id: 5, key: 1}]
          ],
          13:[
              [{id: 5, value_id:12, key: 1}],
              [{id: 2, value_id: 5, key: 1}]
          ],
          14:[
              [{id: 5, value_id: 12, key: 1},{id: 13,value_id:36,key: 1, neq: true}],
              [{id: 2, value_id: 5, key: 1},{id: 13,value_id:36,key: 1, neq: true}],
          ],
          15:[
            [{id: 5,value_id:12,key: 1}],
            [{id: 2,value_id:5,key: 1}]
          ],
          16:[
            [{id: 5,value_id:12,key: 1}],
            [{id: 2,value_id:5,key: 1}]
          ]
      },

  
  [PART_D_MULTIPLE_REPORT]: {

          143: [
            [{id: 'INTERACTIONTYPE',value_id: 'Phone', key: 0}]
        ],
          144:[
              [{id:143, value_id:1 , key: 1}],
              [{id:'INTERACTIONTYPE', value_id: 'Fax', key: 0}]
          ],
          145:[
              [{id:143, value_id: 1, key: 1}],
              [{id:'INTERACTIONTYPE', value_id: 'Fax', key: 0}]
          ],
          146:[
              [{id:143, value_id: 1, key: 1}],
              [{id:'INTERACTIONTYPE', value_id: 'Fax', key: 0}]
          ],
          147:[
              [{id:143, value_id: 1, key: 1}],
              [{id:'INTERACTIONTYPE', value_id: 'Fax', key: 0}]
          ],
          148:[
              [{id:147, value_id: 14, key: 1}]
          ],
          149:[
             [{id: 148,value_id: 15,key:1}]
          ],
          151:[
              [{id:150, value_id: 19, key: 1}]
          ],
          152:[
              [{id:151, value_id: 118, key: 1}]
          ],
          153:[
            [{id:'IS_PROCESS_W_TRANS_OVERRIDE',value_id: 'Yes', key:0}]
          ],
          154:[
              [{id:153,value_id: 36, key: 1}]
          ],
          155:[
              [{id: 154,value_id: 37, key: 1}]
          ],
          156:[
              [{id: 196, value_id: 123, key: 1}]
          ],
          
          157:[
              [{id: 156, value_id: 43, key: 1}]
          ],
          158:[
              [{id: 150,value_id: 19, key: 1}]
          ],
          159:[
              [{id: 158,value_id: 47, key: 1}]
          ],
          160:[
              [{id: 150,value_id: 19, key: 1}]
          ],
          161:[
              [{id: 160,value_id: 50, key: 1}]
          ],
          162:[
              [{id:160,value_id: 51, key: 1}]
          ],
          163:[
              [{id:150,value_id: 19, key: 1},{id:'PYSTATUSWORK',value_id: 'Resolved-Approved',key:0}],
          ],
          164:[
              [{id: 163,value_id:57, key: 1}]
          ],
          165:[
              [{id:150,value_id:20, key: 1}]
          ],
          166:[
              [{id:165,value_id:60, key: 1}]
          ],
          167:[
              [{id:165,value_id:61, key: 1}]
          ],
          168:[
              [{id:194,value_id:121, key: 1}]
          ],
          169:[
             [{id: 168,value_id: 67, key: 1}]
          ],
          170:[
              [{id:194,value_id: 121, key: 1}],
          ],
          172:[
              [{id: 194,value_id: 121, key: 1}]
          ],
          173:[
              [{id: 170,value_id: 71, key: 1}],
              [{id: 172,value_id: 75, key: 1}]
          ],
          174:[
              [{id: 173,value_id: 76, key: 1}]
          ],
          175:[
              [{id: 173,value_id: 76, key: 1}]
          ],
          176:[
              [{id:173,value_id: 76, key: 1}]
          ],
          177:[
              [{id: 172,value_id: 71, key: 1}],
              [{id: 172,value_id: 75, key: 1}]
          ],
          178:[
              [{id:194,value_id: 121, key: 1}]
          ],
          180:[
              [{id: 194,value_id: 121, key: 1}]
          ],
          181:[
            [{id: 180, value_id: 91,key: 1}]
          ],
          182:[
            [{id: 194,value_id: 121, key: 1}]
        ],
          183:[
            [{id: 182, value_id: 95,key: 1}]
          ],
          186:[
            [{id: 185, value_id: 101,key: 1}]
          ],
          187:[
            [{id: 186,value_id:102,key:1}],
            [{id: 186,value_id:103,key:1}]
          ],
          188:[
            [{id: 150, value_id: 19,key: 1}],
            [{id: 185, value_id: 101, key: 1}]
          ],
          189:[
            [{id: 150, value_id: 19,key: 1}]
          ]

      },  

  
  [RESOLVED_COMPLETED_REPORT]: {


        69:[
          [{id: "INTERACTIONTYPE", value_id: 'Fax', key: 0}]
        ],
        70:[
          [{id: "INTERACTIONTYPE", value_id: 'Fax', key: 0}]
        ],
          71:[
              [{id: 70, value_id: 3, key: 1}]
          ],
          72:[
              [{id: 70, value_id: 3, key: 1}]
          ],
          73:[
            [{id: "INTERACTIONTYPE", value_id: 'Fax', key: 0}]
          ],
          74:[
            [{id: "INTERACTIONTYPE", value_id: 'Fax', key: 0}]
          ],
          76:[
              [{id: 75, value_id: 17, key: 1}]
          ],
  
          // I took some privilege in deciding the question
          79:[
              [{id:78,value_id: 27, key: 1}]
          ],
          80:[
              [{id:79,value_id: 28, key: 1}],
              [{id:79,value_id: 30, key: 1}],
              [{id:79,value_id: 50, key: 1}]
          ],
          81:[
             [{id:79,value_id: 28, key: 1}],
             [{id:79,value_id: 30, key: 1}],
             [{id:79,value_id: 50, key: 1}]
          ],
          82:[
              [{id:79,value_id: 28, key: 1}],
              [{id:79,value_id: 30, key: 1}],
              [{id:79,value_id: 50, key: 1}]
          ]
      },

  
  [TRANSITIONAL_OVERRIDE_REPORT]: {

      //There is not interaction variable in file

      84:[
        [{id:'INTERACTIONTYPE',value_id: 'Phone',key: 0}]
      ],

          85:[
              [{id: 84, value_id: 1, key: 1}],
              [{id: 'INTERACTIONTYPE', value_id: 'Fax', key:0}]
          ],
          86:[ 
              [{id: 84, value_id: 1, key: 1}],
              [{id: 'INTERACTIONTYPE', value_id: 'Fax', key:0}]
          ],
          87:[
              [{id: 84, value_id: 1, key: 1}],
              [{id: 'INTERACTIONTYPE', value_id: 'Fax', key:0}]
          ],
          88:[
              [{id: 84, value_id: 1, key: 1}],
              [{id: 'INTERACTIONTYPE', value_id: 'Fax', key:0}]
          ],
          89:[
              [{id: 88, value_id: 13, key: 1}]
          ],
        91:[
              [{id:90,value_id: 18, key: 1}]
          ],
          93:[
               [{id: 90, value_id: 18,key: 1}]
          ],
          95:[
              [{id:94,value_id: 39, key: 1}]
          ],
          96:[
              [{id:95,value_id: 40, key: 1}],
              [{id:95,value_id: 41, key: 1}]
          ],
          97:[
              [{id:94,value_id: 39, key: 1}]
          ],
      },

  
 [UHCEI_DUPLICATE_DENIAL_REPORT]:{

 // something wrong with the reworked PA case
          99: [
              [{id: 98, value_id: 2, key: 1}]
          ],
          100:[
              [{id: 98, value_id: 1, key: 1}]
          ],
          102:[
            [{id: 98, value_id: 2, key: 1}],
            [{id: 191,value_id: 45, key: 1}]
        ],
          103:[
              [{id: 102, value_id: 26, key: 1}]
          ],
          104:[
              [{id: 103, value_id: 42, key: 1}],
              [{id: 103, value_id: 43, key: 1}]
          ],
          105:[
              [{id: 98, value_id: 2, key: 1}],
              [{id: 102, value_id: 26, key: 1}]
          ],
          190:[
              [{id: 98, value_id: 2, key: 1}],
              [{id: 191,value_id: 45, key: 1}]
          ],
          192:[
            [{id: 191,value_id: 45,key:1}]
          ]
      },

  
  [PART_D_PREDETERMINATION_REPORT]: {

          120:[
              [{id:'INTERACTIONTYPE',value_id: 'Phone',key: 0}]
          ],
          121:[
              [{id: 120, value_id: 2, key: 1}],
              [{id: 'INTERACTIONTYPE', value_id: 'Fax', key: 0}]
          ],
          122:[
              [{id: 120, value_id: 2, key: 1}],
              [{id: 'INTERACTIONTYPE', value_id: 'Fax', key: 0}]
          ],
          123:[
              [{id: 120, value_id: 2, key: 1}],
              [{id: 'INTERACTIONTYPE', value_id: 'Fax', key: 0}]
          ],
          125:[
             [{id: 124, value_id: 13, key: 1}]
          ],
          126:[
             [{id:125,value_id:15,key:1}]
          ],
          127:[
            [{id:125,value_id: 16, key: 1}]
          ],
          128:[
              [{id: 125, value_id: 17, key: 1}]
          ],
          129:[
              [{id: 125, value_id: 18, key: 1}]
          ],
          130:[
              [{id: 125, value_id: 19, key: 1}]
          ],
          131:[
              [{id: 125, value_id: 20, key: 1}]
          ],
          132:[
              [{id: 125, value_id: 21, key: 1}]
          ],
          133:[
              [{id: 125, value_id: 22, key: 1}]
          ],
          134:[
              [{id: 125, value_id:23, key: 1}]
          ],
          135:[
              [{id: 125, value_id: 24, key: 1}]
          ],
          138:[
              [{id: 137, value_id: 69, key: 1}]
          ],
          139:[
              [{id: 137, value_id: 69, key: 1}]
          ],
          140:[
              [{id: 138, value_id: 70, key: 1}],
              [{id: 138, value_id: 71, key: 1}]
          ],
          141:[
              [{id:124,value_id: 13, key: 1}]
          ],
          142:[
              [{id: 124, value_id: 13, key: 1}]
          ],
          
      },

  
  [PART_D_IE_REPORT]: {
        // This has radio buttons, don't know how to handle it
        43:[
            [{key:0, id:'INTERACTIONTYPE', value_id: 'Phone'}]
        ],
        44:[
              [{key:1, id: 43, value_id: 1}],
              [{key:0, id:'INTERACTIONTYPE', value_id: 'Fax'}]
          ],
          45:[
              [{id: 43, value_id: 1, key: 1}],
              [{key:0, id:'INTERACTIONTYPE', value_id: 'Fax'}]
          ],
          46:[
              [{id: 43, value_id: 1, key: 1}],
              [{key:0, id:'INTERACTIONTYPE', value_id: 'Fax'}]
          ],
          47:[
              [{id: 43, value_id: 9, key: 1}],
              [{key:0, id:'INTERACTIONTYPE', value_id: 'Fax'}]
          ],
          48:[
               [{id: 43, value_id: 9, key: 1},{id:47, value_id: 11,key: 1, neq: true}],
                [{key:0, id:'INTERACTIONTYPE', value_id: 'Fax'},{id:47, value_id: 11,key: 1, neq: true}],
                    ],
          50:[
              [{id: 49, value_id: 15, key: 1}]
          ],
          51:[
              [{id: 49, value_id: 16, key: 1, neq: true}]
          ],
          53:[
              [{id: 52, value_id: 28, key: 1}]
          ],
          54:[
              [{id: 53, value_id: 30, key: 1}]
          ],
          55:[
              [{id: 53, value_id: 31, key: 1}]
          ],
          56:[
              [{id: 53, value_id: 34, key: 1}]
          ],
          57:[
              [{id: 53, value_id: 32, key: 1}]
          ],
          58:[
              [{id: 53, value_id: 33, key: 1}]
          ],
          59:[
              [{id: 58, value_id: 57, key: 1}]
          ],
          60:[
              [{id:53, value_id: 35, key: 1}]
          ],
          61:[
              [{id: 52,value_id: 28,key: 1}]
          ],
          63:[
              [{id:62,value_id: 71, key: 1}]
          ],
          64:[
              [{id: 63,value_id: 101, key: 1}],
              [{id:63, value_id:102,key:1}],
              [{id: 63,value_id: 103, key: 1}]
          ],
          65:[
              [{id: 62,value_id: 71, key: 1}]
          ],
          193:[
            [{id: 53,value_id: 87,key:1}]
          ]
      },

  
  
  [XCPINDEXING_REPORT]: {

          108:[
             [{id:107,value_id:7,key:1}],
             [{id:107,value_id:8,key:1}]
          ],
          109:[
              [{id: 108, value_id: 10, key: 1}]
          ],
          110:[
              [{id: 108, value_id: 9, key: 1}]
          ],
          111:[
              [{id: 108, value_id: 9, key: 1}]
          ],
          112:[
              [{id: 108, value_id: 10, key: 1}]
          ],
          113:[
              [{id: 108, value_id: 10, key: 1}]
          ],
          114:[
              [{id: 108, value_id: 10, key: 1}]
          ],
          115:[
              [{id: 108, value_id: 10, key: 1}]
          ],
          116:[
              [{id: 108, value_id: 10, key: 1}]
          ]
      }
    }

export const ParsedConditions = {
    [INBOUND_CORR_WB_REPORT]: JSON.stringify(REPORT_CONDITONS[INBOUND_CORR_WB_REPORT]) ,
    [PART_D_DUPLICATE_REPORT]: JSON.stringify(REPORT_CONDITONS[PART_D_DUPLICATE_REPORT]),
    [RESOLVED_COMPLETED_REPORT]: JSON.stringify(REPORT_CONDITONS[RESOLVED_COMPLETED_REPORT]) ,
    [TRANSITIONAL_OVERRIDE_REPORT]:  JSON.stringify(REPORT_CONDITONS[TRANSITIONAL_OVERRIDE_REPORT]) ,
    [UHCEI_DUPLICATE_DENIAL_REPORT]: JSON.stringify(REPORT_CONDITONS[UHCEI_DUPLICATE_DENIAL_REPORT]) ,
    [PART_D_IE_REPORT]:  JSON.stringify(REPORT_CONDITONS[PART_D_IE_REPORT]),
    [XCPINDEXING_REPORT]: JSON.stringify(REPORT_CONDITONS[XCPINDEXING_REPORT]) ,
    [DUAL_ACCOUNT_REPORT]: JSON.stringify(REPORT_CONDITONS[DUAL_ACCOUNT_REPORT]),
    [PART_D_PREDETERMINATION_REPORT]: JSON.stringify(REPORT_CONDITONS[PART_D_PREDETERMINATION_REPORT]),
    [PART_D_MULTIPLE_REPORT]: JSON.stringify(REPORT_CONDITONS[PART_D_MULTIPLE_REPORT]),
  }

//   Take parsedConditions from sessionStorage, do run the below code in your editor, copy it and send it to ashish
//   for(const key in x){
//     console.log(key," ==> ",`'${x[key]}'`)
//     console.log()
// }


//// Check duplicate report 
/// id -> 31 has null option


//* ** code to test the prod and non prod *** *\

// prodData = {"QuestionsData": [{"question_id": 69, "question_text": "Was the Priority Correct"}, {"question_id": 70, "question_text": "Was the Drug Selection Correct"}, {"question_id": 71, "question_text": "What was incorrect with Drug?"}, {"question_id": 72, "question_text": "If No, was a new case created for the correct drug?"}, {"question_id": 73, "question_text": "Does the prescriber information provided on the fax, match what was entered in PAS (name, fax #)?"}, {"question_id": 74, "question_text": "Does the member information provided on the fax, match what was entered in PAS (name, date of birth)?"}, {"question_id": 75, "question_text": "Was the request completed in error?"}, {"question_id": 76, "question_text": "If yes, what was the error?"}, {"question_id": 77, "question_text": "Pending Clarification"}, {"question_id": 78, "question_text": "Is remediation required?"}, {"question_id": 79, "question_text": "If remediation is required, what is type of remediation?"}, {"question_id": 80, "question_text": "New PA # - Reworked Case Only provide request if YOU had to rework the request"}, {"question_id": 81, "question_text": "If a new request is required, what review is needed?"}, {"question_id": 82, "question_text": "Who made the Error?"}, {"question_id": 83, "question_text": "Completed"}], "DropdownData": [{"Drop_Down_Text": "Yes", "Survey_Question_Id": "69", "Id": 1}, {"Drop_Down_Text": "No - If case is standard but should be urgent, is the case timely? If so, rework and add to Manual Monitoring. If not, add to A&M Rph Inquiry SP", "Survey_Question_Id": "69", "Id": 2}, {"Drop_Down_Text": "No", "Survey_Question_Id": "70", "Id": 3}, {"Drop_Down_Text": "Yes", "Survey_Question_Id": "70", "Id": 4}, {"Drop_Down_Text": "Incorrect Brand vs Generic", "Survey_Question_Id": "71", "Id": 5}, {"Drop_Down_Text": "Incorrect formulation", "Survey_Question_Id": "71", "Id": 6}, {"Drop_Down_Text": "Incorrect Strength", "Survey_Question_Id": "71", "Id": 7}, {"Drop_Down_Text": "Wrong drug", "Survey_Question_Id": "71", "Id": 8}, {"Drop_Down_Text": "Yes", "Survey_Question_Id": "72", "Id": 9}, {"Drop_Down_Text": "No - Review Timeliness and rework accordingly", "Survey_Question_Id": "72", "Id": 10}, {"Drop_Down_Text": "Yes", "Survey_Question_Id": "73", "Id": 11}, {"Drop_Down_Text": "No - Name incorrect", "Survey_Question_Id": "73", "Id": 12}, {"Drop_Down_Text": "No - Fax # incorrect", "Survey_Question_Id": "73", "Id": 13}, {"Drop_Down_Text": "Yes", "Survey_Question_Id": "74", "Id": 14}, {"Drop_Down_Text": "No - Name incorrect", "Survey_Question_Id": "74", "Id": 15}, {"Drop_Down_Text": "No - Date of Birth incorrect", "Survey_Question_Id": "74", "Id": 16}, {"Drop_Down_Text": "Yes", "Survey_Question_Id": "75", "Id": 17}, {"Drop_Down_Text": "No", "Survey_Question_Id": "75", "Id": 18}, {"Drop_Down_Text": "ePA request completed incorrectly instead of processing throughPAS", "Survey_Question_Id": "76", "Id": 19}, {"Drop_Down_Text": "Fax request completed incorrectly instead of processing through PAS", "Survey_Question_Id": "76", "Id": 20}, {"Drop_Down_Text": "RxWeb request completed incorrectly instead of processing through PAS", "Survey_Question_Id": "76", "Id": 21}, {"Drop_Down_Text": "No", "Survey_Question_Id": "77", "Id": 22}, {"Drop_Down_Text": "Yes - Logged to A&M for timeliness review", "Survey_Question_Id": "77", "Id": 23}, {"Drop_Down_Text": "No", "Survey_Question_Id": "78", "Id": 24}, {"Drop_Down_Text": "No - Request was already reworked/reprocessed", "Survey_Question_Id": "78", "Id": 25}, {"Drop_Down_Text": "No - Untimely Ruquest (Handled by A&M)", "Survey_Question_Id": "78", "Id": 26}, {"Drop_Down_Text": "Yes", "Survey_Question_Id": "78", "Id": 27}, {"Drop_Down_Text": "Rework required; Coverage Determination is required", "Survey_Question_Id": "79", "Id": 28}, {"Drop_Down_Text": "Missed Appeal; added to AV SP / Forward to AV", "Survey_Question_Id": "79", "Id": 29}, {"Drop_Down_Text": "Rework required to cancel with correct cancellation reason code", "Survey_Question_Id": "79", "Id": 30}, {"Drop_Down_Text": "Claim Dollar", "Survey_Question_Id": "81", "Id": 31}, {"Drop_Down_Text": "MEDLIMIT - Reject Code 88 + 922 + G4 (Hard MME)", "Survey_Question_Id": "81", "Id": 32}, {"Drop_Down_Text": "MEDLIMIT - Reject Code 88 + 922 (Soft MME)", "Survey_Question_Id": "81", "Id": 33}, {"Drop_Down_Text": "New to Therapy - Reject Code 88 + 925 (NTT)", "Survey_Question_Id": "81", "Id": 34}, {"Drop_Down_Text": "Non-Formulary", "Survey_Question_Id": "81", "Id": 35}, {"Drop_Down_Text": "oDDI - Reject Code 88 (eg Benzo+Opioid LA Opioid)", "Survey_Question_Id": "81", "Id": 36}, {"Drop_Down_Text": "PAReqd", "Survey_Question_Id": "81", "Id": 37}, {"Drop_Down_Text": "Quantity", "Survey_Question_Id": "81", "Id": 38}, {"Drop_Down_Text": "Step Therapy", "Survey_Question_Id": "81", "Id": 39}, {"Drop_Down_Text": "Stimulant", "Survey_Question_Id": "81", "Id": 40}, {"Drop_Down_Text": "Tier Exception", "Survey_Question_Id": "81", "Id": 41}, {"Drop_Down_Text": "Review Approval - Duplicate Request", "Survey_Question_Id": "81", "Id": 42}, {"Drop_Down_Text": "Review Approval - Request Approval", "Survey_Question_Id": "81", "Id": 43}, {"Drop_Down_Text": "Duplicate Denial", "Survey_Question_Id": "81", "Id": 44}, {"Drop_Down_Text": "Prior Authorization Technician", "Survey_Question_Id": "82", "Id": 45}, {"Drop_Down_Text": "Pharmacist", "Survey_Question_Id": "82", "Id": 46}, {"Drop_Down_Text": "System", "Survey_Question_Id": "82", "Id": 47}, {"Drop_Down_Text": "Yes", "Survey_Question_Id": "83", "Id": 48}, {"Drop_Down_Text": "No", "Survey_Question_Id": "83", "Id": 49}, {"Drop_Down_Text": "Rework required to forward to AV", "Survey_Question_Id": "79", "Id": 50}], "ConditionsData": [{"ID": 7, "CONDITION": "{\"69\":[[{\"id\":\"INTERACTIONTYPE\",\"value_id\":\"Fax\",\"key\":0}]],\"70\":[[{\"id\":\"INTERACTIONTYPE\",\"value_id\":\"Fax\",\"key\":0}]],\"71\":[[{\"id\":70,\"value_id\":3,\"key\":1}]],\"72\":[[{\"id\":70,\"value_id\":3,\"key\":1}]],\"73\":[[{\"id\":\"INTERACTIONTYPE\",\"value_id\":\"Fax\",\"key\":0}]],\"74\":[[{\"id\":\"INTERACTIONTYPE\",\"value_id\":\"Fax\",\"key\":0}]],\"76\":[[{\"id\":75,\"value_id\":17,\"key\":1}]],\"79\":[[{\"id\":78,\"value_id\":27,\"key\":1}]],\"80\":[[{\"id\":79,\"value_id\":28,\"key\":1}],[{\"id\":79,\"value_id\":30,\"key\":1}],[{\"id\":79,\"value_id\":50,\"key\":1}]],\"81\":[[{\"id\":79,\"value_id\":28,\"key\":1}],[{\"id\":79,\"value_id\":30,\"key\":1}],[{\"id\":79,\"value_id\":50,\"key\":1}]],\"82\":[[{\"id\":79,\"value_id\":28,\"key\":1}],[{\"id\":79,\"value_id\":30,\"key\":1}],[{\"id\":79,\"value_id\":50,\"key\":1}]]}"}], "CaseData": [{"CASEID": "PA-E8651908", "SLACOMPLIANCE": "2025-05-09T08:34:18.020", "CARRIERCODE": "0196", "BUSINESSSEGMENT": "PBM", "PRIORITY": "STANDARD", "INTERACTIONTYPE": "Fax", "REQUESTRECIEVEDDATE": "2025-05-07T08:34:18.020", "DISPOSITIONDATE": "2025-05-07T10:40:41.003", "PATYPETEXT": null, "DRUGNAME": "TESTOSTERONE TD GEL 12.5 MG/ACT (1%)", "PYSTATUSWORK": "Resolved-Completed", "REASONCODE": "Authorization Updated", "ISRESTRICTED": "1"}], "SurveyData": []}

// nonProdData = {"QuestionsData": [{"question_id": 69, "question_text": "Was the Priority Correct"}, {"question_id": 70, "question_text": "Was the Drug Selection Correct"}, {"question_id": 71, "question_text": "What was incorrect with Drug?"}, {"question_id": 72, "question_text": "If No, was a new case created for the correct drug?"}, {"question_id": 73, "question_text": "Does the prescriber information provided on the fax, match what was entered in PAS (name, fax #)?"}, {"question_id": 74, "question_text": "Does the member information provided on the fax, match what was entered in PAS (name, date of birth)?"}, {"question_id": 75, "question_text": "Was the request completed in error?"}, {"question_id": 76, "question_text": "If yes, what was the error?"}, {"question_id": 77, "question_text": "Pending Clarification"}, {"question_id": 78, "question_text": "Is remediation required?"}, {"question_id": 79, "question_text": "If remediation is required, what is type of remediation?"}, {"question_id": 80, "question_text": "New PA # - Reworked Case Only provide request if YOU had to rework the request"}, {"question_id": 81, "question_text": "If a new request is required, what review is needed?"}, {"question_id": 82, "question_text": "Who made the Error?"}, {"question_id": 83, "question_text": "Completed"}], "DropdownData": [{"Drop_Down_Text": "Yes", "Survey_Question_Id": "69", "Id": 1}, {"Drop_Down_Text": "No - If case is standard but should be urgent, is the case timely? If so, rework and add to Manual Monitoring. If not, add to A&M Rph Inquiry SP", "Survey_Question_Id": "69", "Id": 2}, {"Drop_Down_Text": "No", "Survey_Question_Id": "70", "Id": 3}, {"Drop_Down_Text": "Yes", "Survey_Question_Id": "70", "Id": 4}, {"Drop_Down_Text": "Incorrect Brand vs Generic", "Survey_Question_Id": "71", "Id": 5}, {"Drop_Down_Text": "Incorrect formulation", "Survey_Question_Id": "71", "Id": 6}, {"Drop_Down_Text": "Incorrect Strength", "Survey_Question_Id": "71", "Id": 7}, {"Drop_Down_Text": "Wrong drug", "Survey_Question_Id": "71", "Id": 8}, {"Drop_Down_Text": "Yes", "Survey_Question_Id": "72", "Id": 9}, {"Drop_Down_Text": "No - Review Timeliness and rework accordingly", "Survey_Question_Id": "72", "Id": 10}, {"Drop_Down_Text": "Yes", "Survey_Question_Id": "73", "Id": 11}, {"Drop_Down_Text": "No - Name incorrect", "Survey_Question_Id": "73", "Id": 12}, {"Drop_Down_Text": "No - Fax # incorrect", "Survey_Question_Id": "73", "Id": 13}, {"Drop_Down_Text": "Yes", "Survey_Question_Id": "74", "Id": 14}, {"Drop_Down_Text": "No - Name incorrect", "Survey_Question_Id": "74", "Id": 15}, {"Drop_Down_Text": "No - Date of Birth incorrect", "Survey_Question_Id": "74", "Id": 16}, {"Drop_Down_Text": "Yes", "Survey_Question_Id": "75", "Id": 17}, {"Drop_Down_Text": "No", "Survey_Question_Id": "75", "Id": 18}, {"Drop_Down_Text": "ePA request completed incorrectly instead of processing throughPAS", "Survey_Question_Id": "76", "Id": 19}, {"Drop_Down_Text": "Fax request completed incorrectly instead of processing through PAS", "Survey_Question_Id": "76", "Id": 20}, {"Drop_Down_Text": "RxWeb request completed incorrectly instead of processing through PAS", "Survey_Question_Id": "76", "Id": 21}, {"Drop_Down_Text": "No", "Survey_Question_Id": "77", "Id": 22}, {"Drop_Down_Text": "Yes - Logged to A&M for timeliness review", "Survey_Question_Id": "77", "Id": 23}, {"Drop_Down_Text": "No", "Survey_Question_Id": "78", "Id": 24}, {"Drop_Down_Text": "No - Request was already reworked/reprocessed", "Survey_Question_Id": "78", "Id": 25}, {"Drop_Down_Text": "No - Untimely Ruquest (Handled by A&M)", "Survey_Question_Id": "78", "Id": 26}, {"Drop_Down_Text": "Yes", "Survey_Question_Id": "78", "Id": 27}, {"Drop_Down_Text": "Rework required; Coverage Determination is required", "Survey_Question_Id": "79", "Id": 28}, {"Drop_Down_Text": "Missed Appeal; added to AV SP / Forward to AV", "Survey_Question_Id": "79", "Id": 29}, {"Drop_Down_Text": "Rework required to cancel with correct cancellation reason code", "Survey_Question_Id": "79", "Id": 30}, {"Drop_Down_Text": "Claim Dollar", "Survey_Question_Id": "81", "Id": 31}, {"Drop_Down_Text": "MEDLIMIT - Reject Code 88 + 922 + G4 (Hard MME)", "Survey_Question_Id": "81", "Id": 32}, {"Drop_Down_Text": "MEDLIMIT - Reject Code 88 + 922 (Soft MME)", "Survey_Question_Id": "81", "Id": 33}, {"Drop_Down_Text": "New to Therapy - Reject Code 88 + 925 (NTT)", "Survey_Question_Id": "81", "Id": 34}, {"Drop_Down_Text": "Non-Formulary", "Survey_Question_Id": "81", "Id": 35}, {"Drop_Down_Text": "oDDI - Reject Code 88 (eg Benzo+Opioid LA Opioid)", "Survey_Question_Id": "81", "Id": 36}, {"Drop_Down_Text": "PAReqd", "Survey_Question_Id": "81", "Id": 37}, {"Drop_Down_Text": "Quantity", "Survey_Question_Id": "81", "Id": 38}, {"Drop_Down_Text": "Step Therapy", "Survey_Question_Id": "81", "Id": 39}, {"Drop_Down_Text": "Stimulant", "Survey_Question_Id": "81", "Id": 40}, {"Drop_Down_Text": "Tier Exception", "Survey_Question_Id": "81", "Id": 41}, {"Drop_Down_Text": "Review Approval - Duplicate Request", "Survey_Question_Id": "81", "Id": 42}, {"Drop_Down_Text": "Review Approval - Request Approval", "Survey_Question_Id": "81", "Id": 43}, {"Drop_Down_Text": "Duplicate Denial", "Survey_Question_Id": "81", "Id": 44}, {"Drop_Down_Text": "Prior Authorization Technician", "Survey_Question_Id": "82", "Id": 45}, {"Drop_Down_Text": "Pharmacist", "Survey_Question_Id": "82", "Id": 46}, {"Drop_Down_Text": "System", "Survey_Question_Id": "82", "Id": 47}, {"Drop_Down_Text": "Yes", "Survey_Question_Id": "83", "Id": 48}, {"Drop_Down_Text": "No", "Survey_Question_Id": "83", "Id": 49}, {"Drop_Down_Text": "Rework required to forward to AV", "Survey_Question_Id": "79", "Id": 50}], "ConditionsData": [{"ID": 7, "CONDITION": "{\"69\":[[{\"id\":\"INTERACTIONTYPE\",\"value_id\":\"Fax\",\"key\":0}]],\"70\":[[{\"id\":\"INTERACTIONTYPE\",\"value_id\":\"Fax\",\"key\":0}]],\"71\":[[{\"id\":70,\"value_id\":3,\"key\":1}]],\"72\":[[{\"id\":70,\"value_id\":3,\"key\":1}]],\"73\":[[{\"id\":\"INTERACTIONTYPE\",\"value_id\":\"Fax\",\"key\":0}]],\"74\":[[{\"id\":\"INTERACTIONTYPE\",\"value_id\":\"Fax\",\"key\":0}]],\"76\":[[{\"id\":75,\"value_id\":17,\"key\":1}]],\"79\":[[{\"id\":78,\"value_id\":27,\"key\":1}]],\"80\":[[{\"id\":79,\"value_id\":28,\"key\":1}],[{\"id\":79,\"value_id\":30,\"key\":1}],[{\"id\":79,\"value_id\":50,\"key\":1}]],\"81\":[[{\"id\":79,\"value_id\":28,\"key\":1}],[{\"id\":79,\"value_id\":30,\"key\":1}],[{\"id\":79,\"value_id\":50,\"key\":1}]],\"82\":[[{\"id\":79,\"value_id\":28,\"key\":1}],[{\"id\":79,\"value_id\":30,\"key\":1}],[{\"id\":79,\"value_id\":50,\"key\":1}]]}"}], "CaseData": [{"CASEID": "PA-E8651908", "SLACOMPLIANCE": "2025-05-09T08:34:18.020", "CARRIERCODE": "0196", "BUSINESSSEGMENT": "PBM", "PRIORITY": "STANDARD", "INTERACTIONTYPE": "Fax", "REQUESTRECIEVEDDATE": "2025-05-07T08:34:18.020", "DISPOSITIONDATE": "2025-05-07T10:40:41.003", "PATYPETEXT": null, "DRUGNAME": "TESTOSTERONE TD GEL 12.5 MG/ACT (1%)", "PYSTATUSWORK": "Resolved-Completed", "REASONCODE": "Authorization Updated", "ISRESTRICTED": "1"}], "SurveyData": []}

//   const formattedData = (data) => {
//     let groupedData = {};
//     if (data != null || data != undefined) {
//       let groupDropdownvalues = {};
//       let groupQuestions = [];
//       let savedAnswers = {};
//       for (const x of data.DropdownData) {
//         const questionId = x['Survey_Question_Id'];
//         if (groupDropdownvalues[questionId] == null || groupDropdownvalues[questionId] == undefined) {
//           groupDropdownvalues[questionId] = [x['Drop_Down_Text']]
//         } else {
//           groupDropdownvalues[questionId].push(x['Drop_Down_Text'])
//         }
//       }
//       for (const x of data.QuestionsData) {
//         const questionId = x['question_id']
//         groupQuestions.push({
//           id: questionId,
//           question_text: x['question_text'],
//           values: groupDropdownvalues[questionId]
//         })
//       }
//       for (const x of data.SurveyData) {
//         savedAnswers[x['QuestionID']] = x['answer']
//       }
//       groupedData['questions'] = groupQuestions
//       groupedData['CaseData'] = data['CaseData']?.[0]
//       groupedData['conditions'] = data['ConditionsData']?.[0]?.['CONDITION'];
//     }
//     return groupedData;
//   };

//   const nonProdFormattedData = formattedData(nonProdData);
//   const prodFormattedData = formattedData(prodData);

//  // checking the questions 
//   if(nonProdFormattedData['questions'].length !== prodFormattedData['questions'].length){
//     console.log("Question length is not matching")
//   }else{
//       for(const x in prodFormattedData['questions']){
//          // checking id
//          if(prodFormattedData['questions'][x].id !== nonProdFormattedData['questions'][x].id){
//           console.log("Order is not there", prodFormattedData['questions'][x].id)
//          }
//          // checking question text
//          if(prodFormattedData['questions'][x].question_text !== nonProdFormattedData['questions'][x].question_text){
//           console.log("Question text is not matching", prodFormattedData['questions'][x].id)
//          }
//          // checking values
//          if(JSON.stringify(prodFormattedData['questions'][x].values) !== JSON.stringify(nonProdFormattedData['questions'][x].values)){
//           console.log("Values are not matching",prodFormattedData['questions'][x].id)
//          }
//       }
//   }
//   // check the caseData
//   if(JSON.stringify(Object.keys(nonProdFormattedData['CaseData'])) !== JSON.stringify(Object.keys(prodFormattedData['CaseData']))){
//     console.log("Keys of CaseData is not matching")
//   }
//   // check the conditions
//   if(prodFormattedData['conditions'] !== nonProdFormattedData['conditions']){
//     console.log("Conditions are not matching")
//   }
//   console.log(formattedData(nonProdData))

// console.log("Everything is working fine")

